import * as React from "react";

function SvgIterable(props, ref) {
  return (
    <svg viewBox="0 0 36 36" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        opacity={0.25}
        fill="#59c1a7"
        d="M15.346 26.97l11.88-11.88 6.01 6.01-11.88 11.88z"
      />
      <path
        opacity={0.25}
        fill="#36c3f2"
        d="M15.248 9.042l6.01-6.01 11.88 11.879-6.01 6.01z"
      />
      <path
        opacity={0.15}
        fill="#ef3d55"
        d="M3.15 21.05l6.01-6.01 11.88 11.879-6.011 6.01z"
      />
      <path
        opacity={0.15}
        fill="#6a266d"
        d="M3.437 14.691l11.88-11.88 6.01 6.011-11.88 11.88z"
      />
      <circle cx={18.2} cy={6} r={4.3} fill="#6a266d" />
      <circle cx={30.2} cy={18.1} r={4.3} fill="#36c3f2" />
      <circle cx={18.2} cy={30.2} r={4.3} fill="#59c1a7" />
      <circle cx={6.1} cy={18.1} r={4.3} fill="#ef3d55" />
    </svg>
  );
}

export default React.forwardRef(SvgIterable);
